"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto px-4 pt-7" };
const _hoisted_2 = { class: "text-center border-t-1 border-gray-dark border-double bg-white py-2 px-4 mb-2 rounded-lg" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["href"];
const vue_3 = require("vue");
const MasonryGrid_1 = require("../../components/MasonryGrid");
const vue_router_1 = require("vue-router");
const Pagination_vue_1 = __importDefault(require("../../components/Pagination.vue"));
const NewsCard_vue_1 = __importDefault(require("../../components/News/NewsCard.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const newsStore_1 = require("../../stores/news/newsStore");
const newsletterStore_1 = require("../../stores/newsletters/newsletterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NewsCategory',
    setup(__props) {
        const newsStore = (0, newsStore_1.useNewsStore)();
        const newsletterStore = (0, newsletterStore_1.useNewsletterStore)();
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const news = (0, vue_3.computed)(() => newsStore.news.filter((news) => {
            return news.category.includes(route.params.code);
        }));
        const totalNews = (0, vue_3.computed)(() => newsStore.totalNews);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const newsletters = (0, vue_3.computed)(() => newsletterStore.newsletters.filter((newsletter) => {
            return newsletter.category.includes(route.params.code);
        }));
        (0, vue_3.onBeforeMount)(() => {
            newsStore.reset();
        });
        const reloadContent = async () => {
            try {
                await newsStore.getNews(router, {
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    "order[createdDatetime]": 'desc',
                    category: route.params.code
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            try {
                await newsletterStore.getNewsletters(router, {
                    page: 1,
                    itemsPerPage: 5,
                    "order[id]": 'desc',
                    category: route.params.code
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.watchEffect)(() => {
            reloadContent();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)({ 'grid grid-cols-1 md:grid-cols-4 gap-y-px gap-x-7': (0, vue_2.unref)(newsletters).length })
                }, [
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)({ 'col-span-3': (0, vue_2.unref)(newsletters).length })
                    }, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(MasonryGrid_1.MasonryGrid), null, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(news), (article) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(MasonryGrid_1.MasonryGridItem), {
                                        class: "mb-7",
                                        key: article.id
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(NewsCard_vue_1.default, { news: article }, null, 8, ["news"])
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(Pagination_vue_1.default, {
                                total: (0, vue_2.unref)(totalNews),
                                current: page.value,
                                "onUpdate:current": _cache[0] || (_cache[0] = ($event) => ((page).value = $event)),
                                perPage: itemsPerPage.value
                            }, null, 8, ["total", "current", "perPage"])
                        ])
                    ], 2),
                    ((0, vue_2.unref)(newsletters).length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(newsletters), (newsletter) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    class: "p-2 bg-white shadow mb-7",
                                    key: newsletter.id
                                }, [
                                    (0, vue_2.createElementVNode)("a", {
                                        class: "block",
                                        href: newsletter.fileUrl,
                                        target: "_blank"
                                    }, [
                                        (0, vue_2.createElementVNode)("img", {
                                            src: newsletter.thumbnailUrl
                                        }, null, 8, _hoisted_5)
                                    ], 8, _hoisted_4),
                                    (0, vue_2.createElementVNode)("a", {
                                        class: "block text-center font-bold",
                                        href: newsletter.fileUrl,
                                        target: "_blank"
                                    }, (0, vue_2.toDisplayString)(newsletter.title), 9, _hoisted_6)
                                ]));
                            }), 128))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2)
            ]));
        };
    }
});
